import Dashboard from "@pages/Dashboard";
import { CheckPointDetails } from "@pages/Checkpoint/Check-Details";
import CheckPointLocations from "@pages/Checkpoint";
import { CheckPointHistoryDetails } from "@pages/Checkpoint/Check-Details/history";
import { CopyDocuments } from "@pages/Checkpoint/Check-Details/Copy-Documents";
import BulkUpload from "@pages/Checkpoint/Check-Details/Bulk-Upload";
import VendorDetailInfoProfile from "@pages/Vendor-Profile";
import { DashboardCheckPointDetails } from "@pages/Checkpoint/Dashboard-Check-Details";
import SupportOpen from "@pages/Support/Open";
import SupportInprogress from "@pages/Support/InProgress";
import SupportClosed from "@pages/Support/Closed";
import OpenDetails from "@pages/Support/Edit/OpenDetails";
import SupportAddPopup from "@pages/Support/Add/OpenDetails";
import SelfComplianceLogs from "@pages/Logs/DownloadedTaskList";
import ManageAudit from "@pages/Reports/Account";
import ReportsAccount from "@pages/Reports/Account";
import ReportsLocation from "@pages/Reports/Location";
import ReportsVendorHistory from "@pages/Reports/VendorHistory";
import ReportsComplianceScorecard from "@pages/Reports/ComplianceScorecard";
import ReportsVendorCompliance from "@pages/Reports/VendorCompliance";

export const PrivateRoutes = [
  //------------------------------  dashboard  ------------------------------//

  { path: "/dashboard", name: "Dashboard", component: <Dashboard /> },

  //------------------------------  Checkpoint  ------------------------------//

  {
    path: "/checkpoint",
    name: "Checkpoint",
    component: <CheckPointLocations />,
  },
  {
    path: "/checkpoint/details/:id/:date/:code/:listenable/:audit_status/:score",
    name: "Dashboard",
    component: <CheckPointDetails />,
  },
  {
    path: "/dashboard/checkpoint/details/:status/:date/:audit/:listenable",
    name: "Dashboard",
    component: <DashboardCheckPointDetails />,
  },

  {
    path:
      "/checkpoint/details/copy-documents/:id/:date/:code/:checkpoint_id/:mainId/:listenable/:audit_status/:score",
    name: "Dashboard",
    component: <CopyDocuments />,
  },
  {
    path: "/checkpoint/details/bulk-upload/:id/:date/:code/:listenable/:audit_status/:score",
    name: "Dashboard",
    component: <BulkUpload />,
  },
  {
    path:
      "/checkpoint/details/history/:id/:date/:code/:checkpoint_id/:listenable/:audit_status/:score",
    name: "Dashboard",
    component: <CheckPointHistoryDetails />,
  },

  //------------------------------  Vendor Profile  ------------------------------//

  {
    path: "/vendor-profile",
    name: "Dashboard",
    component: <VendorDetailInfoProfile />,
  },
  //------------------------------  Support Service  ------------------------------//

  {
    path: "/support/open",
    name: "location_location",
    component: <SupportOpen />,
  },
  {
    path: "/support/inprogress",
    name: "location_location",
    component: <SupportInprogress />,
  },
  {
    path: "/support/closed",
    name: "location_location",
    component: <SupportClosed />,
  },

  {
    path: "/support/:main_route/add",
    name: "location_location",
    component: <SupportAddPopup />,
  },
  {
    path: "/support/:main_route/details/:id",
    name: "location_location",
    component: <OpenDetails />,
  },

  {
    path: "/self-compliance-logs/:type",
    name: "admin_system_audit_log",
    component: <SelfComplianceLogs />,
  },

    //------------------------------  Reports Service  ------------------------------//

    {
      path: "/reports/account",
      name: "reports_account",
      component: <ReportsAccount />,
    },

    {
      path: "/reports/location",
      name: "reports_location",
      component: <ReportsLocation />,
    },

    {
      path: "/reports/vendor-history",
      name: "reports_vendor_histoy",
      component: <ReportsVendorHistory />,
    },

    {
      path: "/reports/compliance-scorecard",
      name: "reports_compliance_scorecard",
      component: <ReportsComplianceScorecard />,
    },

    {
      path: "/reports/vendor-compliance",
      name: "reports_vendor_compliance",
      component: <ReportsVendorCompliance />,
    },
];
